import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "@/store";
import { updateToken } from "@/features/auth/authSlice";
import { env } from "@/config";

export const useFetchToken = () => {
  const { getAccessTokenSilently } = useAuth0();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);

  if (!env.auth0Audience)
    throw new Error("Failed to find the REACT_APP_AUTH0_AUDIENCE");

  useEffect(() => {
    getAccessTokenSilently({
      detailedResponse: true,
    }).then((response) => {
      dispatch(updateToken(response.access_token));
      setLoading(false);
    });
  }, [dispatch, getAccessTokenSilently]);

  return { isLoading };
};
